import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Features } from '@frontend/containers/Features';
import * as React from 'react';

var FeaturePage = function FeaturePage() {
  return _jsx(Features, {});
};

export var __N_SSG = true;
export default FeaturePage;